import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {RehearsalState} from "./types";
import RehearsalService from "./rehearsal_service";

export const fetchRehearsals = createAsyncThunk(
    'rehearsals/fetchRehearsals',
    async (_, {getState}) => {
        return RehearsalService.getRehearsals();

    }
)

export const addToRehearsal = createAsyncThunk(
    'rehearsals/addToRehearsal',
    async (song_id:string, {dispatch, rejectWithValue}) => {
        try {
            const data = await RehearsalService.addToRehearsal(song_id);

            return data.data;
        } catch (error: any) {
            console.log(error)
            return rejectWithValue(error?.response?.data?.message || error.message);
        }
    }
);

export const getPersonalPractise = createAsyncThunk(
    'rehearsals/getUserPractise',
    async (uuid: string, {getState}) => {
        return RehearsalService.getPersonalPractise(uuid);
    }
)

const initialState: RehearsalState = {
    rehearsals: [],
    rehearsal: null,
    practises: [],
    loading: false,
    error: null
}

export const rehearsalSlice = createSlice({
    name: 'rehearsals',
    initialState,
    reducers: {
        upsertOptimisticPractise: (state, action) => {
            const incoming = action.payload;
            const matchIndex = state.practises.findIndex((practice: any) =>
                String(practice.section || '').toLowerCase() === String(incoming.section || '').toLowerCase()
            );

            if (matchIndex >= 0) {
                state.practises[matchIndex] = {
                    ...state.practises[matchIndex],
                    ...incoming,
                };
                return;
            }

            state.practises.unshift(incoming);
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchRehearsals.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchRehearsals.fulfilled, (state, action) => {
            state.loading = false;
            state.rehearsals = action.payload;
        });
        builder.addCase(fetchRehearsals.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message as string;
        });
        builder.addCase(addToRehearsal.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(addToRehearsal.fulfilled, (state, action) => {
            state.loading = false;
            state.rehearsal = action.payload;
        });
        builder.addCase(addToRehearsal.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message as string;
        });

        builder.addCase(getPersonalPractise.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getPersonalPractise.fulfilled, (state, action) => {
            state.loading = false;
            state.practises = action.payload;
        });
        builder.addCase(getPersonalPractise.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message as string;
        });
    }
});

export default rehearsalSlice.reducer;
export const {upsertOptimisticPractise} = rehearsalSlice.actions;

// export const selectRehearsals = (state: any) => state.rehearsals.rehearsals;
// export const selectRehearsal = (state: any) => state.rehearsals.rehearsal;
// export const selectLoading = (state: any) => state.rehearsals.loading;
// export const selectError = (state: any) => state.rehearsals.error;
